import {
  IOfferPriceBucketRange,
  OfferPriceBucket,
  OfferScheduleType,
  OfferStatusFilterValue,
  OffersFilterKey
} from './OfferFilters.types';

export const ALL_OFFERS_FILTER_KEYS: OffersFilterKey[] = Object.values(OffersFilterKey);

// Sentinel written to the URL when the user explicitly clears every
// checkbox in a filter that has a non-empty default (Status, Schedule).
// Lets us tell "both unchecked by user" apart from "no param yet".
export const URL_EMPTY_SELECTION = 'none';

export const DEFAULT_STATUS_SELECTION: OfferStatusFilterValue[] = [
  OfferStatusFilterValue.ACTIVE,
  OfferStatusFilterValue.INACTIVE
];

export const DEFAULT_SCHEDULE_SELECTION: OfferScheduleType[] = [
  OfferScheduleType.PERMANENT,
  OfferScheduleType.INTERVAL
];

export const ALL_PRICE_BUCKETS: OfferPriceBucket[] = Object.values(OfferPriceBucket);

export const PRICE_BUCKET_RANGES_CENTS: Record<OfferPriceBucket, IOfferPriceBucketRange> = {
  [OfferPriceBucket.FREE]: { min: 0, max: 0 },
  [OfferPriceBucket.UP_TO_5]: { min: 1, max: 499 },
  [OfferPriceBucket.UP_TO_10]: { min: 500, max: 999 },
  [OfferPriceBucket.OVER_10]: { min: 1000, max: null }
};

export const PRICE_BUCKET_LABELS: Record<OfferPriceBucket, string> = {
  [OfferPriceBucket.FREE]: 'Free',
  [OfferPriceBucket.UP_TO_5]: '$0.01 - $4.99',
  [OfferPriceBucket.UP_TO_10]: '$5.00 - $9.99',
  [OfferPriceBucket.OVER_10]: '$10.00+'
};
